var React = require('react');

function Video (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"ICONS_nieuwwwwww"),React.createElement("path",{"d":"M43,.43a40,40,0,1,0,40,40A40,40,0,0,0,43,.43Zm32.23,40A32.23,32.23,0,1,1,43,8.2,32.27,32.27,0,0,1,75.23,40.43Z","fill":"#2a2d58","key":1}),React.createElement("path",{"d":"M57.54,41l.06-.61a2,2,0,0,0,0-.35,2.82,2.82,0,0,0,0-.35l-.18-.58c-.05-.11-.1-.22-.14-.29a2.11,2.11,0,0,0-.22-.34L39.78,20.74a3.29,3.29,0,0,0-2.36-1,3.4,3.4,0,0,0-2.38,1A3.32,3.32,0,0,0,34,23,3.27,3.27,0,0,0,35,25.41l14.59,15L35,55.45a3.35,3.35,0,1,0,4.81,4.67l17-17.48.07-.11.08,0,.26-.52.36-.51-.11-.06s0-.08,0-.12A3,3,0,0,0,57.54,41Z","fill":"#f1b860","key":2})]);
}

Video.defaultProps = {"viewBox":"0 0 86 80.93"};

module.exports = Video;

Video.default = Video;
